const isMac = navigator.platform.toLowerCase().includes("mac");
export {
  isMac
};
